import { Directive, HostListener, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[piqetAngularDecimalLimit]',
})
export class DecimalLimitDirective {
  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target.value;
    if (input && !/^\d+(\.\d{0,2})?$/.test(input)) {
      event.target.value = input.slice(0, -1);
    }
  }

  constructor() {}
}
